import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { useIntl } from '../../util/reactIntl';
import { types as sdkTypes } from '../../util/sdkLoader';
import { Heading, IconSearch } from '../../components';

import css from './ListingPage.module.css';

const { Money } = sdkTypes;

/** Predefined add-ons never show photos (only custom add-ons may have images). */
const PREDEFINED_ADD_ON_KEYS = new Set([
  'prepHelp',
  'deliveryService',
  'setUpHelpAtVenue',
  'diyConsult',
  'strike',
  'rushFee',
]);

const SectionAddOnsMaybe = props => {
    const { publicData } = props;
    const intl = useIntl();

    if (!publicData || !publicData.addOns || publicData.addOns.length === 0) {
        return null;
    }

    const { addOns } = publicData;

    const renderAddOn = (addOn, index) => {
        const { key, label, price, unit, imageUrl } = addOn;

        if (!key || !unit) {
            return null;
        }

        const displayImageUrl = PREDEFINED_ADD_ON_KEYS.has(key) ? null : imageUrl;

        const labelText = label || intl.formatMessage({ id: `EditListingAddOnsForm.addOn${key.charAt(0).toUpperCase() + key.slice(1)}` });

        const priceMaybe = price instanceof Money
            ? price
            : price && price.amount
                ? new Money(price.amount, price.currency)
                : null;

        const formattedPrice = priceMaybe ? formatMoney(intl, priceMaybe) : '';
        const unitText = intl.formatMessage({ id: `EditListingAddOnsForm.unit${unit.charAt(0).toUpperCase() + unit.slice(1)}` });

        return (
            <div key={index} className={css.addOnItem}>
                {displayImageUrl ? (
                    <div className={css.addOnImageWrapper}>
                        <img
                            src={displayImageUrl}
                            alt={labelText}
                            className={css.addOnImage}
                        />
                    </div>
                ) : (
                    <div className={css.dummyImage}>
                        <IconSearch className={css.dummyIcon} />
                    </div>
                )}
                <div className={css.addOnInfo}>
                    <span className={css.addOnLabel}>{labelText}</span>
                    <span className={css.addOnPrice}>
                        {formattedPrice} ({unitText.toLowerCase()})
                    </span>
                </div>
            </div>
        );
    };

    return (
        <div className={css.sectionAddOns}>
            <Heading as="h2" rootClassName={css.sectionHeading}>
                <FormattedMessage id="EditListingAddOnsForm.title" />
            </Heading>
            <div className={css.addOnsContainer}>
                {addOns.map((addOn, index) => renderAddOn(addOn, index))}
            </div>
        </div>
    );
};

export default SectionAddOnsMaybe;
